import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ICustomer } from '@albacross/types'

import { useAddNotification } from 'hooks/useAddNotification'
import { patch } from 'utils/http'

type CustomerUpdateBody = Pick<
  ICustomer,
  'name' | 'website' | 'is_beta' | 'is_partner' | 'is_sales_led' | 'plan_id'
> & { tier?: number }

export const customerToServer = (x: any): CustomerUpdateBody => {
  const tier = Number(x.tier)
  return {
    name: x.name,
    website: x.website,
    is_beta: x.is_beta,
    is_partner: x.is_partner,
    is_sales_led: x.is_sales_led,
    plan_id: +x.plan_id,
    ...(Number.isInteger(tier) && tier >= 1 && tier <= 9 ? { tier } : {}),
  }
}

export const useCustomerUpdate = (customerId: any) => {
  const addNotification = useAddNotification()
  const queryClient = useQueryClient()

  const updateCustomer = async (values: any) => patch(`/management/customers/${customerId}`, customerToServer(values))

  return useMutation({
    mutationFn: updateCustomer,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId] })

      addNotification('Customer updated successfully')
    },
  })
}
